module.exports = __webpack_public_path__ + "img/shi.bc20a298.png";